<template lang="pug">
    div.homeFlexContent
        
        div.mainCol
            div.mainimg
            div.gradient
                v-img.budLogo(src="images/bud.png")
                div.budText 
                    div {{ "Main_BUDMDIC_1" | localize}}
                    div {{ "Main_BUDMDIC_2" | localize}}
                div.burBntWrap(v-if="dictantFile")
                    a.mr-2.mb-2(v-if="dictantFile.fileName" :href="`/res/${dictantFile.key}_${dictantFile.fileName}`") {{ "Main_PICHITAT" | localize}}
                    a(v-if="dictantFile.watchLink" :href="dictantFile.watchLink") {{ "Main_POSMOTRET" | localize}}
                //- div.burBntWrap
                    a.mr-2.mb-2(href="/res/DIKTANT_2022.pdf") {{ "Main_PICHITAT" | localize}} 
                    a(href="https://vk.com/udmurtdiktant?z=video-43073775_456243558%2F0311f27923fc119423%2Fpl_wall_-37249272") {{ "Main_POSMOTRET" | localize}}
        
        div.rigthCol
            //a.rigthColitem(href="http://удмуртия100.рф" style="background-image: url(/images/100-let.png);")
            a.rigthColitem(href="https://udmkyl.ru/" style="background-image: url(/images/udmky.jpg);")


            //a.rigthColitem(href="https://rodniki.udmurt.media" style="background-image: url(/images/rodnik.png);")
            a.rigthColitem(href="https://vk.com/daurtv" style="background-image: url(/images/daurtv.jpg);")
                

            a.rigthColitem(href="https://даур.рф" style="background-image: url(/images/daur.png);")
                

</template>


<script>
    import { mapState } from "vuex";
    export default {
        computed: {
            ...mapState(['dictantFile'])
        }
    }
</script>

<style lang="scss" scoped>
    .homeFlexContent {
        display:flex;
        flex-wrap: wrap;
    }
    .mainCol{
        position: relative;
        overflow: hidden;
        height: 210px;
        flex-basis: 100%;
        margin-bottom: 16px;
    }
    .rigthCol{
        flex-basis: 100%;
        overflow: hidden;
        display: flex;
        flex-wrap:wrap;
    }
    .mainimg {
        background: url(/images/girl.jpg) no-repeat center;
        background-size: cover;
        height: 100%;
    }
    .gradient {
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(183, 7, 7, 0.4) 54.17%, rgba(183, 7, 7, 0.4) 99.99%, rgba(255, 255, 255, 0) 100%)
    }
    .gradient2 {
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background:linear-gradient(180deg, rgba(149, 149, 149, 0.5) 99.99%, rgba(255, 255, 255, 0) 100%)
    }
    .rigthColitem {
        overflow: hidden;
        margin-bottom: 16px;
        flex-basis: 100%;
        height: 210px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        //height: 100%;
        position: relative;
    }
    .rigthColitem:hover .gradient2 {display: none;}
    .budLogo {
        width:19%;
        height:auto;
        margin: 3% 0 0 11%;
    }
    .budText {
        margin: 3% 0 0 11%;
        color:#fff;
        font-size: 16px;
    }
    .burBntWrap {
        font-style: italic;
        width: 250px;
        font-weight: normal;
        margin: 3% 0 0 11%;
    }
    .burBntWrap a {
        padding: 6px 10px;
        display:inline-block;
        background: #fff;
        text-align: center;
        align-items: center;
        font-style: italic;
        background: #fff;
        text-decoration: none;
        color: #505254;
        font-family: Segoe UI;
        border-radius: 4px;
    }
    .newText {
        font-weight: bold;
        font-size: 24px;
        color: #FFFFFF;
        width:270px;
        position: absolute;
        bottom: 10px;
        left: 10px;
        line-height: 25px;
    }
    @media (min-width:600px) {
        .mainCol{
            height: 500px;
            flex-basis: 100%;
            margin-bottom: 16px;
        }
        .rigthCol{
            flex-basis: 100%;
        }
        .rigthColitem {
            flex:1 1 auto;
            height: 210px;
        }
        .rigthColitem:nth-child(2) {
            margin:0 3.33%;
        }
        
    }
    @media (min-width:960px) {
        .mainCol{
            height: 500px;
            flex-basis: 73%;
            margin:0 2% 0 0;
        }
        .rigthCol{
            flex-basis: 25%;
        }
        .rigthColitem {
            flex-basis: 100%;
            height: 156px;
            margin: 0 0 16px 0;
        }
        .rigthColitem:nth-child(2) {
            margin: 0 0 16px 0;
        }
        .rigthColitem:last-child {
            margin: 0;
        }
    }
    @media (min-width:1264px) {
        .mainCol{
            height: 500px;
            flex-basis: 73%;
            margin:0 2% 0 0;
        }
        .rigthColitem {
            height: 156px;
        }
        .budText {
            margin: 5% 0 0 11%;
            font-size: 24px;
        }
        .burBntWrap {
            margin: 5% 0 0 11%;
            width: 340px;
            font-size: 24px;
        }
    }
    @media (min-width:1904px) {
        .mainCol{
            height: 656px;
            flex-basis: 73%;
            margin:0 2% 0 0;
        }
        .rigthColitem {
            height: 208px;
        }
        .budLogo {
            margin: 8% 0 0 11%;
        }
        .budText {
            font-size: 24px;
            margin: 5% 0 0 11%;
        }
        .burBntWrap {
            width: 340px;
            margin: 5% 0 0 11%;
            font-size: 24px;
        }
    }
</style>